import { useAppSelector } from "../../../../../services/redux/hooks/use-selector";
import { selectSpaUriObject } from "../../../redux/selectors";
import { LinkClipboard } from "../SpaLinkSettings/LinkClipboard";
import { LinkEditName } from "../SpaLinkSettings/LinkEditName";
import { LinkTransferController } from "../SpaLinkSettings/LinkTransferController";
import styles from "./styles.module.css";

interface Props {
  onOpenChangeSpaNameModal: () => void;
  id: string;
}

export const SpaLinkEditor = (props: Props) => {
  const spaUriObject = useAppSelector(selectSpaUriObject);
  const handleTransferPublishVersion = () => {
    window.open(`https://${spaUriObject?.uri?.relative_uri}`, "_blank");
  };

  return (
    <div className={styles["edit-wrapper"]}>
      <LinkEditName
        onClick={props.onOpenChangeSpaNameModal}
        spa={spaUriObject?.uri?.relative_uri ?? ""}
        id={props.id}
      />
      <LinkTransferController
        handleTransferPublishVersion={handleTransferPublishVersion}
        isDisabled={
          spaUriObject?.publish?.ref === "" ||
          spaUriObject?.publish?.ref === undefined
        }
      />
      <LinkClipboard
        onClick={() =>
          navigator.clipboard.writeText(
            `https://${spaUriObject?.uri?.relative_uri}`,
          )
        }
        isDisabled={
          spaUriObject?.publish?.ref === "" ||
          spaUriObject?.publish?.ref === undefined
        }
      />
    </div>
  );
};
